// extracted by mini-css-extract-plugin
export default {"dialog":"style_dialog__Fhzkh","results":"style_results__Fk4qT","highlighted":"style_highlighted__-jtkn","choices-counter":"style_choices-counter__lHS4V"};